import PersonalCenter from './profile-progressive';

export default PersonalCenter;
